import { Component, OnInit, ViewChild, inject } from '@angular/core'
import { Observable } from 'rxjs'

import { HuntPackageRecord } from '@cyborg-monorepo/hunter/common'

import { HuntPackageComponent } from '../../../../../../shared/components/hunt-package/hunt-package.component'
import { HuntPackageService } from '../../../../../../shared/services/hunt-package.service'

@Component({
  standalone: false,
  selector: 'cyborg-hunt-packages',
  templateUrl: './recently-updated.component.html',
})
export class HuntPackageContentComponent implements OnInit {
  private huntPackageService = inject(HuntPackageService)

  @ViewChild(HuntPackageComponent) public huntPackage: HuntPackageComponent
  public recentHuntPackages$: Observable<Array<HuntPackageRecord>>

  public ngOnInit(): void {
    this.recentHuntPackages$ = this.huntPackageService.getRecentHuntPackages(5)
  }
}
